import React, { useState, useEffect, useRef } from "react";

import {ThemeProvider} from "styled-components";
import  {useDarkMode} from "../components/useDarkMode"
import { GlobalStyles } from "../components/Globalstyle";
import { lightTheme, darkTheme } from "../components/Themes"
import "./App.css";
import Body from "../components/Body";
import Brand from "../components/Brand";
import Logo from "../components/Logo";
import Header from "../components/Header";
import HeaderBody from "../components/HeaderBody";
import Wallet from "../components/Wallet";
import NetworkBanner from "../components/NetworkBanner";
import NoWalletModal from "../components/NoWalletModal";

import Oracle from "../components/Oracle";

import { IMAGES_FOLDER, supportedChains, swaapURI } from "../config"

import { getWeb3 } from "../web3/web3"

import { useOnClickOutside } from "../hooks/rendering";

import { chainMapping, weiFormat } from "../config"


function App() {

	const [isConnectedToWeb3, setIsConnectedToWeb3] = useState()
	const [web3, setWeb3] = useState()
	const [isWalletConnected, setIsWalletConnected] = useState(false)

	const [theme, themeToggler, mountedComponent] = useDarkMode();
	const [isTrade, setIsTrade] = useState(true);
	const [appChainID, setAppChainID] = useState();

	const [account, setAccount] = useState();
	const [isMyAccountConnected, setIsMyAccountConnected] = useState(false);

	const [contractAddress, setContractAddress] = useState()

	const ref = useRef();
	const [showNoWalletModal, setShowNoWalletModal] = useState(false)
	useOnClickOutside(ref, () => setShowNoWalletModal(false));

	const [whitelist, setWhitelist] = useState()
	const [defaultToken, setDefaultToken] = useState()

	useEffect(() => {
		handleWeb3()
	}, [])

	useEffect(() => {
		if (window.ethereum) {
			setIsWalletConnected(true)
			window.ethereum.request({ method: 'eth_chainId' })
			.then(chainId => handleChainId(chainId))
		} else {
			setIsWalletConnected(false)
		}
	}, [isConnectedToWeb3])

	// refresh account
	useEffect(() => {
		if (isWalletConnected) {
			window.ethereum.on('accountsChanged', function (accounts) {
			  getAccount()
			})
			window.ethereum.request({ method: 'eth_chainId' })
			.then(chainId => handleChainId(chainId))
			window.ethereum.on('chainChanged', (chainId) => {
				handleChainId(chainId);
				window.location.reload();
			})
			handleWeb3()
		}
    }, [isWalletConnected])

    useEffect(() => {
    	if (appChainID && chainMapping.hasOwnProperty(appChainID)) {
			setContractAddress(chainMapping[appChainID]["contract"])
			setWhitelist(Object.values(chainMapping[appChainID]["whitelist"]))
			setDefaultToken(chainMapping[appChainID]["whitelist"][chainMapping[appChainID]["defaultToken"]])
		}
    }, [appChainID])

	function getAccount() {
		if (isWalletConnected) {
			window.ethereum.request({ method: 'eth_requestAccounts' })
			.then(accounts => {
				if (accounts) {
					setAccount(accounts[0])
					setIsMyAccountConnected(accounts[0] != undefined)
				} else {
					setAccount()
					setIsWalletConnected(false)
				}
			})
		}
	}

	const themeMode = theme === "light" ? lightTheme : darkTheme;

	function handleWeb3() {
		const [_isConnectedToWeb3, _web3] = getWeb3()
		setIsConnectedToWeb3(!isConnectedToWeb3)
		setWeb3(undefined)
		setIsConnectedToWeb3(_isConnectedToWeb3)
		setWeb3(_web3)
    }

    function handleConnection() {
    	if (!isConnectedToWeb3) {
			handleWeb3()
		}
		if (isConnectedToWeb3) {
			getAccount()
		} else {
			setShowNoWalletModal(true)
		}
    }

	function handleChainId(chainId) {
		setAppChainID(parseInt(chainId.toString(), 16))
	}

	if(!mountedComponent) return <div/>

	return (
		<>
			<ThemeProvider theme={themeMode}>
				<GlobalStyles />
				<div className="App">

					<Header>

						<NetworkBanner appChainID={appChainID} supportedChains={supportedChains} />

						<HeaderBody >
							<div style={{display: "flex"}}>
								<Logo theme={themeMode} toggleTheme={themeToggler} />
								<Brand href={swaapURI}><div className="BrandFont">Swaap.</div></ Brand>
							</div>
							<Wallet
								isConnectedToWeb3={isConnectedToWeb3}
								isMyAccountConnected={isMyAccountConnected}
								connectionHandler={handleConnection}
								account={account}
							/>
						</ HeaderBody>
					</ Header>

					<Body>
						<Oracle
							web3={web3}
							account={account}
							isConnectedToWeb3={isConnectedToWeb3}
							isMyAccountConnected={isMyAccountConnected}
							contractAddress={contractAddress}
							whitelist={whitelist}
							defaultToken={defaultToken}
						/>

						{
							showNoWalletModal ?
							<NoWalletModal handleRef={ref}/>
							: <div></div>
						}

					</ Body>

				</ div>
			</ ThemeProvider>
		</ >
	);

};


export default App;
